import React, { Component } from 'react';
import { connect } from 'react-redux';

class OrdersBid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ordersPerPage: 10,
      currentPage: 1,
      currentPair: '',
    };
    this.setCurrentPage = this.setCurrentPage.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { pair } = this.props;
    if (prevProps.pair !== pair) {
      this.setCurrentPage(1);
    }
  }

  setCurrentPage(number) {
    const { currentPage } = this.state;
    if (currentPage !== number) {
      this.setState({
        currentPage: number,
      });
    }
  }

  render() {
    const { order, exchA, exchB, currencySign, toLocaleFixed, pair, user, isOfType } = this.props;
    const { ordersPerPage, currentPage } = this.state;

    let indexOfLastOrder;
    let indexOfFirstOrder;
    let currentOrders;
    let ordersLength;
    let buyOrders;

    if (order && order.liquidity && order.liquidity.BUY) {
      buyOrders = order.liquidity.BUY;
      indexOfLastOrder = currentPage * ordersPerPage;
      indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
      // currentOrders = buyOrders.slice(indexOfFirstOrder, indexOfLastOrder);
      currentOrders = buyOrders;
      ordersLength = buyOrders.length;
    }

    let currencyHandle;

    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      currencyHandle = user.me.defaults.currencyHandle;
    }

    const tableLoop = currentOrders && currentOrders.map((order, index) => {
      let useTrunc = false;
      // if (pair !== 'DASHBTC') {
      //   useTrunc = true;
      // }
      let useSum;
      let truncSum;
      if (order.sum) {
        useSum = order.sum;
        truncSum = order.sum.toString().slice(0, (order.sum.indexOf('.')) + 4);
        if (useTrunc) {
          useSum = truncSum;
        }
      }
      let useQuant;
      let truncQuant;
      if (order.quantity) {
        useQuant = order.quantity;
        truncQuant = order.quantity.toString().slice(0, (order.quantity.indexOf('.')) + 4);
        if (useTrunc) {
          useQuant = truncQuant;
        }
      }
      return (
        <tr key={index}>
          {pair === 'DASHBTC' ? (
            null
          ) : (
            <td>{useSum || ''}</td>
          )}
          <td className="hide-mob">{order.total || ''}</td>
          <td>{useQuant || ''}</td>
          <td>
            {currencySign(order.currencyHandle || '')}
            {toLocaleFixed((order.currencyValue / 100), 2) || ''}
          </td>
          <td>{order.price || ''}</td>
        </tr>
      );
    });

    if (currentOrders && currentOrders.length) {
      return (
        <table className="t-bid">
          <thead>
            <tr>
              {pair === 'DASHBTC' ? (
                null
              ) : (
                <th>
                  Sum
                  { isOfType(exchA, 'METAL') ? (
                    <span style={{ textTransform: 'lowercase' }}> (g)</span>
                  ) : (
                    <span> ({exchA})</span>
                  )}
                </th>
              )}
              <th className="hide-mob">Sum ({exchB})</th>
              <th>
                Volume
                { isOfType(exchA, 'METAL') ? (
                  <span style={{ textTransform: 'lowercase' }}> (g)</span>
                ) : (
                  <span> ({exchA})</span>
                )}
              </th>
              <th>Bid ({currencySign(currencyHandle || '')})</th>
              <th>Bid</th>
            </tr>
          </thead>
          <tbody>
            {tableLoop}
          </tbody>
        </table>
      );
    }

    return (
      <div>
        <table className="t-bid">
          <thead>
            <tr>
              {pair === 'DASHBTC' ? (
                null
              ) : (
                <th>
                  Sum
                  { isOfType(exchA, 'METAL') ? (
                    <span style={{ textTransform: 'lowercase' }}> (g)</span>
                  ) : (
                    <span> ({exchA})</span>
                  )}
                </th>
              )}
              <th className="hide-mob">Sum ({exchB})</th>
              <th>
                Volume
                { isOfType(exchA, 'METAL') ? (
                  <span style={{ textTransform: 'lowercase' }}> (g)</span>
                ) : (
                  <span> ({exchA})</span>
                )}
              </th>
              <th>Bid ({currencySign(currencyHandle || '')})</th>
              <th>Bid</th>
            </tr>
          </thead>
        </table>
        <h3 style={{ textAlign: 'center' }}>No Data</h3>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  order: state.order,
});

export default connect(mapStateToProps)(OrdersBid);
